import React from 'react';
import { IPosition } from '../../shared/types';
import DataTable from '../../components/tables/DataTable';

// ...

interface Props {
  fullPositions: IPosition[];
  decimals: number; // Número de decimales para formatear cantidades
}

const PositionsTable: React.FC<Props> = ({ fullPositions, decimals }) => {
  return (
    <DataTable
      title="Positions"
      count={fullPositions.length}
      columns={[]} // Columns are now defined within DataTable
      data={fullPositions}
      type="positions"
      decimals={decimals}
    />
  );
};

export default PositionsTable;
